import React, { Component } from 'react';
import PropTypes from 'prop-types';
import parseUrl from 'video-service-url-parser';
import YouTubePlayer from './YouTubePlayer';
import EditableThumbnail from '../editableMediaThumbnail';
import Icon from '../gfx/Icon';

class YouTube extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        onSubmit: PropTypes.func,
        url: PropTypes.string.isRequired,
        description: PropTypes.string,
        dimensions: PropTypes.object.isRequired,
    };

    state = { playing: false };

    onIncludeVideo() {
        this.setState({ playing: true });
    }

    editClicked() {
        this.setState({ playing: false });
    }

    getThumbUrl() {
        return `//i1.ytimg.com/vi/${
            parseUrl(this.props.url).videoId
        }/mqdefault.jpg`;
    }

    render() {
        return (
            <React.Fragment>
                {this.state.playing ? <YouTubePlayer {...this.props} /> : null}
                <EditableThumbnail
                    clickable
                    defaultValue={this.props.description}
                    disabled={this.props.disabled}
                    editClicked={this.editClicked.bind(this)}
                    editLabel={'Endre beskrivelse'}
                    hidden={this.state.playing}
                    imgSrc={this.getThumbUrl()}
                    label={'Beskrivelse'}
                    onClick={this.onIncludeVideo.bind(this)}
                    onSubmit={this.props.onSubmit}
                    placeholder={'Beskrivelse'}
                    playIcon={
                        <div className="play-icon">
                            <Icon height={20} type="play" width={20} />
                        </div>
                    }
                >
                    {this.props.children}
                </EditableThumbnail>
            </React.Fragment>
        );
    }
}

export default YouTube;
